module.exports = __webpack_public_path__ + "static/media/CoreUI-Icons-Linear-Free.089ab3c1.eot";